module.exports = __webpack_public_path__ + "img/3-image1.c2b21229.png";